module.exports = __webpack_public_path__ + "static/media/stock_out_32_blue.9dd9676e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/stock_out_32_blue.svg
// module id = 313
// module chunks = 0